import { useNavigate } from "react-router-dom";
import { CheckCircle2, Eye, RefreshCw, ChevronRight } from "lucide-react";
import { EngagementAction, EngagementActionType } from "@models/engagementAction";

interface ActionRowProps {
  action: EngagementAction;
}

const ICONS: Record<EngagementActionType, React.ReactNode> = {
  APPROVE: <CheckCircle2 size={18} />,
  REVIEW: <Eye size={18} />,
  REBRAND: <RefreshCw size={18} />,
};

const TYPE_LABELS: Record<EngagementActionType, string> = {
  APPROVE: "Approve",
  REVIEW: "Review",
  REBRAND: "Rebrand",
};

export default function ActionRow({ action }: ActionRowProps) {
  const navigate = useNavigate();
  const onClick = () => {
    if (action.type === "REBRAND") {
      navigate(`/engagements/${action.engagement_id}/content`);
      return;
    }
    navigate(`/my-todos/review/${action.id}`);
  };

  return (
    <div className="mt-action-row" onClick={onClick} role="button" tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter") onClick(); }}>
      <div className="mt-action-row__icon">{ICONS[action.type]}</div>
      <div className="mt-action-row__body">
        <div className="mt-action-row__primary">
          <span className="mt-action-row__type">{TYPE_LABELS[action.type]}</span>
          <span className="mt-action-row__sep">·</span>
          <span className="mt-action-row__adname">{action.ad_name}</span>
        </div>
        <div className="mt-action-row__secondary">
          {action.engagement_name} · {action.launch_name}
        </div>
      </div>
      <div className="mt-action-row__cta">
        {action.type === "REBRAND" ? "Edit" : "Review"} <ChevronRight size={16} />
      </div>
    </div>
  );
}
